// extracted by mini-css-extract-plugin
export default {"application-answer":"style_application-answer__joon4","applicationAnswer":"style_application-answer__joon4"};